import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  BaseDetailBulkItemDataFragment,
  GetBulkItemDocument,
} from '../../types/api/graphql';

const useBulkMessageItem = (id?: string | null) => {
  const { data: bulkItemData, loading: bulkItemDataLoading } = useQuery(
    GetBulkItemDocument,
    {
      variables: {
        id: id ?? '',
      },
      skip: !id,
      fetchPolicy: 'network-only',
    }
  );

  const data: BaseDetailBulkItemDataFragment | undefined = useMemo(
    () =>
      (bulkItemData?.bulkCampaign as BaseDetailBulkItemDataFragment) ??
      undefined,
    [bulkItemData?.bulkCampaign]
  );

  return {
    data,
    loading: bulkItemDataLoading,
  };
};
export { useBulkMessageItem };
